var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('supermarket-story-share-frame',[_c('food-income-ratio',{attrs:{"cashflows":_vm.cashflows}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }